/**
 * Conversion helpers between database format (snake_case) and app format (camelCase).
 * The prototype uses camelCase (createdBy, tagPoints, etc.) but PostgreSQL
 * conventionally uses snake_case (created_by, tag_points, etc.).
 *
 * We could enforce one or the other everywhere, but converting at the boundary
 * lets us keep both worlds happy.
 */

// Convert a single object's keys from snake_case to camelCase.
export function toCamel(obj) {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) return obj.map(toCamel);
  if (typeof obj !== 'object') return obj;
  if (obj instanceof Date) return obj;

  const result = {};
  for (const key of Object.keys(obj)) {
    const camelKey = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    result[camelKey] = toCamel(obj[key]);
  }
  return result;
}

// Convert a single object's keys from camelCase to snake_case.
export function toSnake(obj) {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) return obj.map(toSnake);
  if (typeof obj !== 'object') return obj;
  if (obj instanceof Date) return obj;

  const result = {};
  for (const key of Object.keys(obj)) {
    const snakeKey = key.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);
    result[snakeKey] = toSnake(obj[key]);
  }
  return result;
}
